import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@telus-uds/components-web';
import { Box } from '../../../../design/css';
import { Container, Tag, RemoveTagButton, Input, Textarea } from './css';

function validateEmail(email) {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
}
function EmailInput({
  emails,
  body,
  subject,
  setEmails,
  setBody,
  setSubject,
  hasError = false
}) {
  const [inputValue, setInputValue] = useState('');
  const [
    isEmailInvalidMessageVisible,
    setEmailInvalidMessageVisible
  ] = useState(false);

  const handleInputChange = event => {
    setInputValue(event.target.value);
  };

  const handleKeyDown = event => {
    if (event.key === 'Enter' && inputValue !== '') {
      if (validateEmail(inputValue)) {
        setEmails([...emails, inputValue]);
        setInputValue('');
        setEmailInvalidMessageVisible(false);
      } else {
        setEmailInvalidMessageVisible(true);
      }

      event.preventDefault();
    } else if (event.key === 'Backspace' && inputValue === '') {
      setEmails(emails.slice(0, -1));
    }
  };

  const handleRemoveTag = index => {
    setEmails(emails.filter((_, i) => i !== index));
  };

  const handleSubjectChange = event => {
    setSubject(event.target.value);
  };

  const handleBodyChange = event => {
    setBody(event.target.value);
  };

  return (
    <>
      <Container>
        <Typography>To: {!emails.length ? 'No recipients added' : ''}</Typography>
        {emails.map((email, index) => (
          <Tag key={index}>
            {email}
            <RemoveTagButton onClick={() => handleRemoveTag(index)}>
              x
            </RemoveTagButton>
          </Tag>
        ))}
        <Input
          type="text"
          placeholder="To (Type email and press enter)"
          value={inputValue}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
        />
        {isEmailInvalidMessageVisible && (
          <span style={{ fontSize: 12, color: 'red', marginTop: -4 }}>
            Invalid Email (enter a valid email and press enter)
          </span>
        )}
        {hasError && inputValue && !emails.length && (
          <span style={{ fontSize: 12, color: 'red', marginTop: -4 }}>
            Press enter to add email
          </span>
        )}
      </Container>
      <Box mt={6} />
      <Input
        id="subject"
        type="text"
        placeholder="Subject (optional)"
        value={subject}
        onChange={handleSubjectChange}
      />
      <Box mt={6} />
      <Textarea
        id="body"
        value={body}
        onChange={handleBodyChange}
        placeholder="Email body"
      />
    </>
  );
}

EmailInput.propTypes = {
  emails: PropTypes.arrayOf(PropTypes.string).isRequired,
  body: PropTypes.string.isRequired,
  subject: PropTypes.string.isRequired,
  setEmails: PropTypes.func.isRequired,
  setBody: PropTypes.func.isRequired,
  setSubject: PropTypes.func.isRequired,
  hasError: PropTypes.bool
};

export default EmailInput;
